import { connect } from 'react-redux';

import { setAuthError as setError, setAuthBusyState as setBusy, login } from 'client/actions';
import PhoneLogIn from './PhoneLogIn';

const mapState = state => ({
	user: state.user,
});

const mapDispatch = {
	login,
	// init,
	setError,
	setBusy,
};

export default connect(mapState, mapDispatch)(PhoneLogIn);
